

import { selectedSitesActions } from './actions';
import { selectionSiteMutations } from './mutations';
import { selectedSitesGetters } from './getters';

const state = {
    selectedSitesFleet: []
};
const actions = { ...selectedSitesActions };
const mutations = { ...selectionSiteMutations };
const getters = { ...selectedSitesGetters };


// eslint-disable-next-line import/prefer-default-export
export const selectedSitesStore = {
    namespaced: true,
    state, actions, mutations, getters,
};
